import React, { PureComponent } from "react";
import { connect } from "react-redux";
import TourSidebarLink from "./TourSidebarLink";
import TourSidebarCategory from "./TourSidebarCategory";
import {
  changeThemeToDark,
  changeThemeToLight
} from "../../../../redux/actions/themeActions";
import { withRouter } from "react-router-dom";
import { signout } from "../../../../redux/actions/userActions";
import { setReload } from "../../../../redux/actions/apolloActions";
import frameworkMapping from "../../../../utils/frameworkMapping";
import subModuleMapping from "../../../../utils/subModuleMapping";

class TourSidebarContent extends PureComponent {
  changeToDark = () => {
    this.props.dispatch(changeThemeToDark());
    this.hideSidebar();
  };

  changeToLight = () => {
    this.props.dispatch(changeThemeToLight());
    this.hideSidebar();
  };

  hideSidebar = () => {
    this.props.onClick();
  };

  signoutUser() {
    this.props.signout();
    this.props.history.push("/");
  }

  render() {
    return this.props.user && this.props.settings ? (
      <div className="sidebar__content">
        <TourSidebarLink
          title="Getting Started"
          id="tour-get-started"
          icon="question-circle"
          route="/app/getting-started"
        />
        <hr />
        <TourSidebarLink
          title="Dashboard"
          id="tour-dashboard-nav"
          icon="home"
          route="/app/tour/dashboard"
        /> 
          <TourSidebarLink
            id="assessment-dropdown"
            title="Assessment"
            icon="pencil"
            route="/app/assessment"
          />
          <TourSidebarLink
            id="tour-playbook-dropdown"
            title="Compliance Playbook"
            icon="book"
            route="/app/tour/playbook/hipaa"
          />
          <TourSidebarLink
            title="Marketplace"
            id="marketplace-nav"
            icon="store"
            route="/app/tour/marketplace"
          />
            <TourSidebarCategory
              id="training-nav"
              title="Training"
              icon="bullhorn"
            >
              {this.props.settings.sub_modules.map((subModule)=>{
                if(subModule.sub_module_name == 'training'){return subModule.categories}})[0].includes(subModuleMapping.HIPAA_TRAINING)?
              (
                <li
                  id="hippa-playbook-nav"
                  className="sidebar__link"
                  onClick={() => this.props.history.push("/app/training/hipaa")}
                >
                  <p className="sidebar__link-title">HIPAA</p>
                </li>
              )
              :null}
              {this.props.settings.sub_modules.map((subModule)=>{
                if(subModule.sub_module_name == 'training'){return subModule.categories}})[0].includes(subModuleMapping.SECURITY_TRAINING)?
              (
                <li
                  id="hippa-playbook-nav"
                  className="sidebar__link"
                  onClick={() => this.props.history.push("/app/training/security")}
                >
                  <p className="sidebar__link-title">Security</p>
                </li>
              )
              :null}
              {this.props.settings.sub_modules.map((subModule)=>{
                if(subModule.sub_module_name == 'training'){return subModule.categories}})[0].includes(subModuleMapping.PCI_TRAINING)?
              (
                <li
                  id="hippa-playbook-nav"
                  className="sidebar__link"
                  onClick={() => this.props.history.push("/app/training/pci")}
                >
                  <p className="sidebar__link-title">PCI</p>
                </li>
              )
              :null}
            </TourSidebarCategory>
        <hr />
          <TourSidebarCategory
            id="tour-compliance-dropdown"
            title="Compliance"
            icon="layers"
          >
            {this.props.enabledFrameworks &&
            this.props.enabledFrameworks.length > 0
              ? this.props.enabledFrameworks.map(f => {
                  return f.id ? (
                    <li
                      id={`${frameworkMapping[f.id].name}-compliance-nav`}
                      key={f.id}
                      className="sidebar__link"
                      onClick={() => {
                        this.props.history.push(
                          `/app/compliance/${frameworkMapping[f.id].path}`
                        )
                        localStorage.setItem('path', frameworkMapping[f.id].path)
                        localStorage.setItem('status', frameworkMapping[f.id].flat)
                      }  
                      }
                    >
                      <p className="sidebar__link-title">
                        {frameworkMapping[f.id].humanName}
                      </p>
                    </li>
                  ) : null;
                })
              : null}
          </TourSidebarCategory>
        <hr />
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    settings: state.auth.settings,
    refetchQuery: state.apollo.refetch,
    enabledFrameworks: state.controlsData.enabledFrameworks
  };
}

export default withRouter(
  connect(mapStateToProps, { signout, setReload })(TourSidebarContent)
);



// WEBPACK FOOTER //
// ./src/components/tour/dashboard/sidebar/TourSidebarContent.js